import { useRouter } from "@tanstack/react-router";
import { ArrowRight } from "@untitled-ui/icons-react";
import { useTranslation } from "react-i18next";

import NotFoundImage from "@/assets/images/not-found.png";
import { logError } from "@/utils/logger";

import Button from "../forms/Button";
import Text from "../text/Text";

export default function ErrorComponent({ error }: { error: Error }) {
  logError(error);

  const router = useRouter();
  const { t } = useTranslation("core.shared");
  return (
    <div className="flex h-full flex-col items-center px-24 py-20">
      <div className="flex h-full w-full max-w-[1280px] items-center justify-between gap-12 px-8">
        <div className="flex flex-col gap-12">
          <Text weight="semibold" color="primary">
            {t("Error")}
          </Text>
          <Text size="6xl" weight="semibold">
            {t("Error occurred")}
          </Text>
          <Text size="xl" weight="normal" color="gray">
            {t("Sorry, you do not have access to this page")}
            <br />
            {t("Here are some useful links for you")}:
          </Text>
          <div className="flex gap-3">
            <Button
              color="secondary-gray"
              size="xl"
              startIcon={<ArrowRight className="h-5 w-5" />}
              onClick={() => router.history.back()}
            >
              {t("Back")}
            </Button>
            <Button size="xl" link={{ to: "/" }}>
              {t("Home")}
            </Button>
          </div>
        </div>
        <img src={NotFoundImage} />
      </div>
    </div>
  );
}
